import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {showAlertMessage} from "../../../modules/alert";
import {showToastMessage} from "../../../modules/toast";
import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/functions';
import _ from "underscore";

import NaverPlaceReviewsActionSheet from './naverPlaceReviewsActionSheet';
import NavigationActionSheet from './navigationActionSheet';
import RoadViewActionSheet from './roadViewActionSheet';
import {hideLoaderMessage, showLoaderMessage} from "../../../modules/loader";
import {OPEN_EXTERNAL_LINK} from "../../../modules/variable/common_variable";


class TargetNaverPalceActionSheet extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});

        this.state = {
            roadViewActionSheet: {open: false, frameUrl: null},
            naverPlaceReviewsActionSheet: {open: false, targetMarker: null},
            navigationSelectorActionSheet: {open: false, target: null},
        };
    }

    showNaverPlaceReviewsActionSheet = (event, marker) => {
        event.stopPropagation();
        this.setState({naverPlaceReviewsActionSheet: {open: true, targetMarker: marker}});
    };

    addInterestingPlace = (marker) => {
        //console.log(marker);
        let parsedInterestingPlace = [];
        if(localStorage.getItem('savedInterestingPlace')){
            try {
                parsedInterestingPlace = JSON.parse(localStorage.getItem('savedInterestingPlace'));
            } catch (e) {console.error(e);}
        }

        if(!_.findWhere(parsedInterestingPlace, {id: marker.id})){
            parsedInterestingPlace.push(marker);
            localStorage.setItem('savedInterestingPlace', JSON.stringify(parsedInterestingPlace));
            this.props.showToastMessage('관심 장소에 추가되었습니다.');
        }else{
            this.props.showToastMessage('이미 추가한 관심 장소입니다.');
        }
    };

    goToScheduleList = (type, parameter) => {
        this.props.history.push({
            pathname: '/listSchedule',
            state: {type: type, parameter: parameter}
        });
    };

    openNavigationSelector = (target) => {
        this.setState({navigationSelectorActionSheet: {...this.state.navigationSelectorActionSheet, open: true, target: target}})
    };


    render() {
        const TNPAS = this.props.targetNaverPlaceActionSheet;
        const NSAS = this.state.navigationSelectorActionSheet;

        return (
            <div>
                <ActionSheet className="home-naver-place-action-sheet" isOpen={TNPAS.open} animation='default' modifier={'material'} onCancel={() => this.props.hideTNPAS()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material naver-place-only-action-sheet-title">{TNPAS.targetMarker ? TNPAS.targetMarker.name : null} <small>(사이트: 네이버 플레이스)</small></div>
                    <div className="card card--material">
                        <div className="home-naver-place-iframe-wrapper">
                            <iframe title="home-naver-place-iframe" src={TNPAS.open ? 'https://m.store.naver.com/attractions/detail?id=' + TNPAS.targetMarker.id + '&back=false' : null}/>
                        </div>
                        <div className="text-center">
                            <div className="tabbar tabbar--top tabbar--material">
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={(event) => this.showNaverPlaceReviewsActionSheet(event, TNPAS.targetMarker)}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-comments"></i>
                                        <div className="tabbar__label tabbar--material__label">리뷰</div>
                                    </button>
                                </label>
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.addInterestingPlace(TNPAS.targetMarker)}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-thumbtack"></i>
                                        <div className="tabbar__label tabbar--material__label">관심 장소 등록</div>
                                    </button>
                                </label>
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.setState({roadViewActionSheet: {open: true, frameUrl: ['https://m.map.naver.com/viewer/panorama.nhn?street=on&pinType=site&pinId=', TNPAS.targetMarker.id].join('')}})}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-road"></i>
                                        <div className="tabbar__label tabbar--material__label">로드뷰</div>
                                    </button>
                                </label>
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.openNavigationSelector(TNPAS.targetMarker)}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-car"></i>
                                        <div className="tabbar__label tabbar--material__label">내비게이션</div>
                                    </button>
                                </label>
                                {/*<label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.goToScheduleList('SHARE', {placeId: TNPAS.targetMarker.id, placeName: TNPAS.targetMarker.name})}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-search-plus"></i>
                                        <div className="tabbar__label tabbar--material__label">이곳이 포함된 일정</div>
                                    </button>
                                </label>*/}
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.props.showAlertMessage("프레임 안에 보이는 네이버 플레이스 사이트의 일부 기능은 정상적으로 작동되지 않을 수 있습니다. 필요한 기능이 작동하지 않는다면 '외부 링크로 보기' 버튼을 눌러 웹 브라우져로 확인해 주세요.", "네이버 플레이스 제한 사항")}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-question"></i>
                                        <div className="tabbar__label tabbar--material__label">제한 사항</div>
                                    </button>
                                </label>
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => OPEN_EXTERNAL_LINK(TNPAS.open ? 'https://m.store.naver.com/attractions/detail?id=' + TNPAS.targetMarker.id + '&back=false' : null)}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-external-link-alt"></i>
                                        <div className="tabbar__label tabbar--material__label">외부 링크로 보기</div>
                                    </button>
                                </label>
                            </div>
                        </div>
                    </div>
                    <ActionSheetButton className="action-sheet-close" onClick={() => this.props.hideTNPAS()} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                </ActionSheet>

                {
                    this.state.roadViewActionSheet.open ?
                        <RoadViewActionSheet open={this.state.roadViewActionSheet.open} frameUrl={this.state.roadViewActionSheet.frameUrl} hide={() => this.setState({roadViewActionSheet: {...this.state.roadViewActionSheet, open: false}})}/>
                        :
                        null
                }


                {
                    this.state.naverPlaceReviewsActionSheet.open ?
                        <NaverPlaceReviewsActionSheet targetMarker={this.state.naverPlaceReviewsActionSheet.targetMarker} hide={() => this.setState({naverPlaceReviewsActionSheet: {...this.state.naverPlaceReviewsActionSheet, open: false}})}/>
                        :
                        null
                }

                {
                    NSAS.open ?
                        <NavigationActionSheet NSAS={NSAS} hide={() => this.setState({navigationSelectorActionSheet: {...this.state.navigationSelectorActionSheet, open: false}})}/>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TargetNaverPalceActionSheet))
